import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { DynamicFiledSetting } from '../../../dynamic-report-modal/dynamic-report-model';
import * as DynamicFormUtils from '../../dynamic-form-utils';

@Component({
  selector: 'app-check-barcode-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './check-barcode-field.component.html',
  styleUrl: './check-barcode-field.component.scss'
})
export class CheckBarcodeFieldComponent implements OnInit {
  @Input() field: DynamicFiledSetting;
  /** Wired by DynamicFieldDirective.updateSubmitState(); errors only render once true. */
  isSubmitted = false;

  formGroup: FormGroup;
  isRequire: Boolean;
  rows = 10;

  constructor(private readonly formGroupDirective: FormGroupDirective) {
    this.formGroup = formGroupDirective.control;
  }

  get control(): AbstractControl | null {
    return this.formGroup?.get(this.field.fieldName) ?? null;
  }

  ngOnInit(): void {
    this.isRequire = DynamicFormUtils.getIsRequiredForm(this.formGroup, this.field.fieldName);

    if (this.field.disabled) {
      DynamicFormUtils.disabledField(this.formGroup, this.field.fieldName);
    }
  }
}
